import type { Targeting, TPredicateMode } from '@feathr/blackbox';

export const MAX_GROUP_NUM_SIZE = 10000000;
export const MATCH_ANY_GROUP_ID = -3;

/**
 * Determine the segmented control value based on the current interest targetings.
 * @returns TPredicateMode - determines whether we're in `match_any` or `match_all` mode
 */
export function determineInterestsMatchMode(interestTargetings: Targeting[]): TPredicateMode {
  const groupIds = interestTargetings.map((t) => t.get('group'));
  if (groupIds.length === 0 || groupIds.includes(MATCH_ANY_GROUP_ID)) {
    return 'match_any';
  } else {
    return 'match_all';
  }
}

export function generateUniqueGroupId(): number {
  return Math.floor(Math.random() * MAX_GROUP_NUM_SIZE);
}

export function getGroupIdForInterest(matchMode: TPredicateMode): number {
  if (matchMode === 'match_any') {
    return MATCH_ANY_GROUP_ID;
  } else {
    return generateUniqueGroupId();
  }
}
